/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var OverrideActionStatus;

(function (OverrideActionStatus) {
  OverrideActionStatus["APPROVED"] = "approved";
  OverrideActionStatus["REJECTED"] = "rejected";
  OverrideActionStatus["PENDING"] = "pending";
})(OverrideActionStatus || (OverrideActionStatus = {}));